module.exports = __webpack_public_path__ + "static/9-86d4ace916703faf0577953cb01b817b.jpeg";